import { BuildingUnitTenancy, axios } from 'shared';
import { BuildingUnit } from 'store/Tenancy/types';

import { SaasLead, TenancyService } from './types';

export const getBuildingUnits = ({ tenancyId }: { tenancyId: number }) => {
  return axios.get<BuildingUnit[]>(`v2/tenancies/${tenancyId}/building_units`);
};

export const getBuildingUnitTenancies = ({ tenancyId }: { tenancyId: number }) => {
  return axios.get<BuildingUnitTenancy[]>(`v2/tenancies/${tenancyId}/building_unit_tenancies`);
};

export const getSaasLead = ({ tenancyId }: { tenancyId: number }) => {
  return axios.get<SaasLead | null>(`v2/tenancies/${tenancyId}/saas_leads`);
};

export const createSaasLead = ({ tenancyId }: { tenancyId: number }) => {
  return axios.post<SaasLead>(`v2/tenancies/${tenancyId}/saas_leads`);
};

export const getActiveServices = ({ tenancyId }: { tenancyId: number }) => {
  return axios.get<TenancyService[]>(`v2/tenancies/${tenancyId}/services`);
};

export const deletePaymentMethod = ({ paymentMethodId, tenancyId }: { paymentMethodId: string; tenancyId: number }) => {
  return axios.delete(`v2/tenancies/${tenancyId}/payment_methods/${paymentMethodId}`);
};

export const updateTenancyPaymentMethodIds = ({
  paymentMethodIdServices,
  paymentMethodIdRent,
  tenancyId
}: {
  paymentMethodIdServices?: string;
  paymentMethodIdRent?: string;
  tenancyId: number;
}) => {
  const payload: Record<string, string> = {};

  if (paymentMethodIdServices !== undefined) {
    payload.payment_method_id_services = paymentMethodIdServices;
  }

  if (paymentMethodIdRent !== undefined) {
    payload.payment_method_id_rent = paymentMethodIdRent;
  }

  return axios.put(
    `v2/tenancies/${tenancyId}/payment_methods/${
      paymentMethodIdServices ? paymentMethodIdServices : paymentMethodIdRent
    }`,
    payload
  );
};
